<template>
    <div class="vc-header">
        <TheNavbar />
        <FavoritePagesBar />
        <SideNav />
        <FavoritePagesTourCard />
        <Toast />
    </div>
</template>

<script>
import SideNav from './SideNav.vue';
import TheNavbar from './TheNavbar.vue';
import Toast from './Toast.vue';
import FavoritePagesBar from './FavoritePagesBar.vue';
import FavoritePagesTourCard from './FavoritePagesTourCard.vue';

export default {
    name: 'TheHeader',
    components: { FavoritePagesTourCard, Toast, SideNav, TheNavbar, FavoritePagesBar },
};
</script>

<style lang="scss" scoped>
.vc-header {
    background-color: $kat-squid-ink-700;
    color: white;
    font-family: $font-family-base;
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 30px;
    text-decoration: none;
}
</style>
